export const LOCATION_COOKIE_MAX_AGE_DAYS = 365;
export const LOCATION_COOKIE_NAME = 'location';

export const DEFAULT_LIMITED_TO_PROVINCE = false;
export const RADIUS_OPTIONS = [
  5, 10, 15, 25, 50, 100, 150, 250, 500, 750, 1000,
];
